import { useCallback } from 'react';
import { scrollToWithHeaderHeight } from '../ScrollUtils';
import { useBoolState } from './useHook';
/**
 * 登録導線フォーム表示を制御するuse
 * @param scrollSelector
 * @param isGuest
 * @param onScrollTo
 * @returns {{isShowForm: boolean, onSubmitAfter: ((function(): void)|*), hideModal: (function(): void), isShowModal: boolean, scrollToForm: ((function(): void)|*)}}
 */
const useRegistrationCtaForm = (scrollSelector, isGuest, onScrollTo) => {
    // 登録導線のフォーム表示制御
    const { boolState: isShowForm, changeFalse: hideForm } = useBoolState(isGuest);
    // 完了モーダルの制御
    const { boolState: isShowModal, changeFalse: hideModal, changeTrue: openModal, } = useBoolState();
    /**
     * 送信後にフォームを非表示 + 完了モーダルを表示
     * @type {(function(): void)|*}
     */
    const onSubmitAfter = useCallback(() => {
        openModal();
        hideForm();
    }, [openModal, hideForm]);
    /**
     * 登録導線までスクロール
     * @type {(function(): void)|*}
     */
    const scrollToForm = useCallback(() => {
        if (onScrollTo) {
            onScrollTo();
        }
        scrollToWithHeaderHeight(scrollSelector);
    }, [onScrollTo, scrollSelector]);
    return {
        hideModal,
        isShowForm,
        isShowModal,
        onSubmitAfter,
        scrollToForm,
    };
};
export const useRegistrationCta = {
    useRegistrationCtaForm,
};
export default useRegistrationCta;
